import { combineReducers } from '@reduxjs/toolkit';
import undoable from 'redux-undo';
import documentSlice from './user/document-slice';
import publicBoardSlice from './user/public-board-slice';
import userInfoSlice from './common/user-info-slice';
import userListSlice from './admin/user-list-slice';
import keywordManageSlice from './admin/keyword-mamange-slice';
import gradeSubjectManageSlice from './admin/grade-subject-mamange-slice';
import constantsSlice from './common/constants-slice';
import recommendedContentsManageSlice from './admin/recommended-contents-manage-slice';
import saveSlice from './user/save-slice';
import authModalSlice from './user/auth-modal-slice';
import workbookSlice from './user/workbook-slice';
import contentsSlice from './common/contents-slice';
import creatorsSlice from './common/creators-slice';
import tempDataSlice from './user/temp-data-slice';
import steamAISlice from './user/steam-ai-slice';
import steamXRSlice from './user/steam-xr-slice';
import allContentsManageSlice from './admin/contents-list-slice';
import classRoomsSlice from './common/classrooms-slice';
import createClassRoomSlice from './user/create-classroom-slice';
import creatorsDetailSlice from './user/creators-detail-slice';
import followSlice from './user/follow-slice';
import classDocumentSlice from './user/class-document-slice';
import steamMoleSlice from './user/steam-mole-slice';
import observatorySlice from './user/observatory-slice';
import classRoomPlaySlice from './user/classroom-play-slice';
import allContentsDetailManage from './admin/contents-detail-slice';
import tutorialContentListSlice from './admin/tutorial-content-list-slice';
import tutorialCategoryManageSlice from './admin/tutorial-category-mamange-slice';
import communityBoardSlice from './admin/community-board-slice';
import issueAccountModalSlice from './user/issue-account-modal-slice';
import storesSlice from './common/store-slice';
import tutorialSlice from './common/tutorial-slice';
import dashBoardSlice from './common/dashboard-slice';
import figure3dSlice from './user/figure3d-slice';
import algebra3dSlice from './user/algebra3d-slice';

export const reducers = {
  common: combineReducers({
    userInfo: userInfoSlice.reducer,
    constants: constantsSlice.reducer,
    contents: contentsSlice.reducer,
    creators: creatorsSlice.reducer,
    classRooms: classRoomsSlice.reducer,
    stores: storesSlice.reducer,
    tutorial: tutorialSlice.reducer,
    dashboard: dashBoardSlice.reducer,
  }),
  admin: combineReducers({
    userList: userListSlice.reducer,
    keywordManage: keywordManageSlice.reducer,
    gradeSubjectManage: gradeSubjectManageSlice.reducer,
    recommendedContentsManage: recommendedContentsManageSlice.reducer,
    allContentsManage: allContentsManageSlice.reducer,
    allContentsDetailManage: allContentsDetailManage.reducer,
    tutorialContentList: tutorialContentListSlice.reducer,
    tutorialCategoryManage: tutorialCategoryManageSlice.reducer,
    communityBoardManage: communityBoardSlice.reducer,
  }),
  user: combineReducers({
    document: documentSlice.reducer,
    publicBoard: publicBoardSlice.reducer,
    algebra3d: algebra3dSlice.reducer,
    workbook: workbookSlice.reducer,
    save: saveSlice.reducer,
    authModal: authModalSlice.reducer,
    tempData: tempDataSlice.reducer,
    steamAI: steamAISlice.reducer,
    steamXR: steamXRSlice.reducer,
    steamMole: steamMoleSlice.reducer,
    figure3d: figure3dSlice.reducer,
    observatory: observatorySlice.reducer,
    classRoom: createClassRoomSlice.reducer,
    creatorDetail: creatorsDetailSlice.reducer,
    follow: followSlice.reducer,
    classDocuments: classDocumentSlice.reducer,
    classRoomPlay: classRoomPlaySlice.reducer,
    issueAccountModal: issueAccountModalSlice.reducer,
  }),
};

export const actions = {
  common: {
    userInfo: userInfoSlice.actions,
    constants: constantsSlice.actions,
    contents: contentsSlice.actions,
    creators: creatorsSlice.actions,
    classRooms: classRoomsSlice.actions,
    stores: storesSlice.actions,
    tutorial: tutorialSlice.actions,
    dashboard: dashBoardSlice.actions,
  },
  admin: {
    userList: userListSlice.actions,
    keywordManage: keywordManageSlice.actions,
    gradeSubjectManage: gradeSubjectManageSlice.actions,
    recommendedContentsManage: recommendedContentsManageSlice.actions,
    allContentsManage: allContentsManageSlice.actions,
    tutorialContentList: tutorialContentListSlice.actions,
    tutorialCategoryManage: tutorialCategoryManageSlice.actions,
    communityBoardManage: communityBoardSlice.actions,
  },
  user: {
    document: documentSlice.actions,
    publicBoard: publicBoardSlice.actions,
    algebra3d: algebra3dSlice.actions,
    workbook: workbookSlice.actions,
    save: saveSlice.actions,
    authModal: authModalSlice.actions,
    tempData: tempDataSlice.actions,
    steamAI: steamAISlice.actions,
    steamXR: steamXRSlice.actions,
    steamMole: steamMoleSlice.actions,
    figure3d: figure3dSlice.actions,
    observatory: observatorySlice.actions,
    classRoom: createClassRoomSlice.actions,
    creatorDetail: creatorsDetailSlice.actions,
    follow: followSlice.actions,
    classDocument: classDocumentSlice.actions,
    classRoomPlay: classRoomPlaySlice.actions,
    issueAccountModal: issueAccountModalSlice.actions,
  },
};
